import { render, staticRenderFns } from "./CardMenu.vue?vue&type=template&id=fc57f826&"
import script from "./CardMenu.vue?vue&type=script&lang=js&"
export * from "./CardMenu.vue?vue&type=script&lang=js&"
import style0 from "./CardMenu.vue?vue&type=style&index=0&id=fc57f826&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports